import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'generic-form',
  styles: [require('./generic-form.component.css').toString()],
  templateUrl: 'generic-form.component.html',
})
export class GenericFormComponent {
  metadataName?: string;
  selectedId?;
  isEditorVisible: boolean = false;
  onGridItemSelect: (arg: any) => void;

  private _subscriptions = [];
  private allMetadataNames = ['SecurityAdministration', 'ClientContacts', 'OrdersWindowsWeb']

  constructor(
    private _router: Router,
    private _route: ActivatedRoute
  ) {
    this.onGridItemSelect = this.goToDetailsPage.bind(this)
    this.afterEditorSuccess = this.afterEditorSuccess.bind(this);
    this.onEditorBack = this.onEditorBack.bind(this);
  }
  
  afterEditorSuccess = () => {
    this._router.navigate(['../'], { relativeTo: this._route });
  }
  
  onEditorBack = () => {
    this._router.navigate(['../'], { relativeTo: this._route });
  }

  goToDetailsPage(entityID: string | number) {
    this._router.navigate([this._router.url, entityID]);
  }

  ngOnInit() {

    this._subscriptions.push(
      this._route.params.subscribe((params) => {
        this.metadataName = params.metadataName;
        this.selectedId = params.id !== 'new' ? params.id : undefined;
        this.isEditorVisible = this.selectedId || params.id === 'new';
      })
    );
  }

  ngOnDestroy() {

    this._subscriptions.forEach((s) => s.unsubscribe());

    this._subscriptions = [];
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-form.component.ts